import React, { type ReactElement, type ReactNode } from 'react';

import styles from './NativeAppsLink.module.scss';

type NativeAppsLinkProps = {
    children: ReactNode;
    link: string;
};

const NativeAppsLink = ({ children, link }: NativeAppsLinkProps): ReactElement => (
    <a href={link} target="_blank" rel="noopener noreferrer" className={styles.link}>
        {children}
    </a>
);

export default NativeAppsLink;
